import { useEffect } from "react";
import { createKeyboardNavigation } from "./keyboard-navigation";

export const useKeyboardNavigation = ({
  uploadButtonRef
}) => {
  const {
    handleKeyDown,
    handleTabKeyNavigation,
    setupTabNavigation,
    focusUploadButton
  } = createKeyboardNavigation({
    uploadButtonRef
  });

  useEffect(() => {
    const cleanup = setupTabNavigation();
    return cleanup;
  }, []);

  return {
    handleKeyDown,
    focusUploadButton
  };
};
